import { NotificationContext } from './NotificationContext';
import NotificationProvider from './NotificationProvider';
import { useNotificationContext } from './useNotificationContext';
import {
  NOTIFICATION_DEFAULT_DELAY,
  NOTIFICATION_DEFAULT_ERROR_MESSAGE,
  NOTIFICATION_DEFAULT_INFO_MESSAGE,
  NOTIFICATION_DEFAULT_SUCCESS_MESSAGE,
  NOTIFICATION_DEFAULT_WARNING_MESSAGE,
} from './consts';
import { NotificationColors, NotificationDataByType, NotificationDataType, NotificationContextType } from './types';

export type { NotificationDataByType, NotificationDataType, NotificationContextType };

export {
  NotificationContext,
  useNotificationContext,
  NOTIFICATION_DEFAULT_DELAY,
  NOTIFICATION_DEFAULT_ERROR_MESSAGE,
  NOTIFICATION_DEFAULT_INFO_MESSAGE,
  NOTIFICATION_DEFAULT_SUCCESS_MESSAGE,
  NOTIFICATION_DEFAULT_WARNING_MESSAGE,
  NotificationColors,
};

export default NotificationProvider;
